/* ===========================================================================
   Bespoke mobile menu — own open/close + drill-down panel stack.
   No theme drawer code. Views slide in/out via the `.is-active` class on
   [data-bmm-view] panels; a stack tracks depth so "back" always works.
   =========================================================================== */
(function () {
  'use strict';

  function init() {
    var menu = document.getElementById('BespokeMenu');
    if (!menu || menu.__bmm) return;
    menu.__bmm = true;

    // Move the overlay to <body> so it escapes the sticky header's stacking
    // context and sits above third-party fixed widgets (chat, review tab).
    if (menu.parentNode !== document.body) document.body.appendChild(menu);

    var toggle = document.querySelector('.bmm-toggle');
    var stage = menu.querySelector('.bmm__stage');
    var stack = [];

    function lock(on) {
      document.documentElement.classList.toggle('bmm-lock', on);
      document.body.classList.toggle('bmm-lock', on);
    }

    function openMenu() {
      // Build the category and brand views the first time the menu opens.
      var views = menu.querySelector('template[data-bmm-views]');
      if (views) views.replaceWith(views.content);
      menu.hidden = false;
      void menu.offsetWidth; // reflow so the open transition runs
      menu.classList.add('is-open');
      lock(true);
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function resetViews() {
      for (var i = 0; i < stack.length; i++) {
        stack[i].classList.remove('is-active');
        stack[i].style.zIndex = '';
      }
      stack = [];
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      lock(false);
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        if (!menu.classList.contains('is-open')) {
          menu.hidden = true;
          resetViews();
        }
      }, 340);
    }

    function openView(id) {
      var view = null;
      var all = stage.querySelectorAll('[data-bmm-view]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute('data-bmm-view') === id) { view = all[i]; break; }
      }
      if (!view) return;
      stack.push(view);
      view.style.zIndex = String(stack.length + 1);
      void view.offsetWidth;
      view.classList.add('is-active');
    }

    function back() {
      var view = stack.pop();
      if (view) view.classList.remove('is-active');
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        openMenu();
      });
    }

    menu.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;

      if (t.closest('[data-bmm-close]')) { closeMenu(); return; }

      var opener = t.closest('[data-bmm-open]');
      if (opener) { e.preventDefault(); openView(opener.getAttribute('data-bmm-open')); return; }

      if (t.closest('[data-bmm-back]')) { e.preventDefault(); back(); return; }
      // <a href> rows fall through and navigate normally.
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
